import React from 'react';
import { useNavigate } from 'react-router-dom';

import { FavouriteAccessPointData } from '../../api/types';
import { AccessPointTile } from '../AccessPointCard/AccessPointTile';

interface FavouriteAccessPointProps {
    accessPoint: FavouriteAccessPointData;
}

const FavouriteAccessPoint: React.FC<FavouriteAccessPointProps> = ({ accessPoint }) => {
    const navigate = useNavigate();

    const onFavouriteClick = (code: string) => {
        navigate(`/accesspoint/${code}`);
    };

    return <AccessPointTile accessPoint={accessPoint} onClick={onFavouriteClick} />;
};

interface FavouriteAccessPointWrapperProps {
    accessPoint: FavouriteAccessPointData;
}

export const FavouriteAccessPointWrapper = React.forwardRef<HTMLDivElement, FavouriteAccessPointWrapperProps>(
    ({ accessPoint, ...props }, ref) => (
        <div ref={ref} {...props}>
            <FavouriteAccessPoint accessPoint={accessPoint} />
        </div>
    )
);
